var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.7,
    fill: "#FAFBFD",
    stroke: "#E0E0E0",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2512 12.6673C23.2512 12.648 23.2475 12.6308 23.2452 12.6122C23.2415 12.5795 23.234 12.5474 23.2259 12.5169C23.2236 12.5072 23.2236 12.4976 23.2199 12.4886L22.2169 9.45796C22.1275 9.18541 21.8721 9.00074 21.5839 9.00074L10.671 9C10.3828 9 10.1274 9.18467 10.038 9.45721L9.035 12.4879C9.035 12.4879 9.03128 12.5072 9.02904 12.5162C9.01936 12.5467 9.01415 12.5787 9.00968 12.6115C9.00745 12.6308 9.00596 12.648 9.00372 12.6666C9.00372 12.6763 9 12.6874 9 12.6971V19.6834C9 21.5115 10.4871 23 12.3166 23H19.9381C21.7662 23 23.2547 21.5129 23.2547 19.6834L23.2562 12.6977C23.2562 12.6865 23.2539 12.6768 23.2524 12.6672L23.2512 12.6673ZM11.1512 10.3344H21.1005L21.6627 12.0307H10.5912L11.1534 10.3344H11.1512ZM21.9196 19.6828C21.9196 20.7752 21.029 21.665 19.9374 21.665H12.3165C11.2241 21.665 10.3344 20.7743 10.3344 19.6828L10.3336 13.365H21.9204V19.6841L21.9196 19.6828Z",
    fill: "#EF3826"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5746 19.9762C15.6982 20.1593 15.906 20.268 16.1271 20.268C16.3483 20.268 16.5538 20.1593 16.6797 19.9762L18.3343 17.5382C18.5421 17.2328 18.4624 16.8173 18.1571 16.6118C17.8518 16.4041 17.4363 16.4837 17.2307 16.789L16.7943 17.4317V15.1769C16.7943 14.809 16.495 14.5097 16.1271 14.5097C15.7593 14.5097 15.4599 14.809 15.4599 15.1769V17.4317L15.0235 16.789C14.8158 16.4837 14.4018 16.4041 14.0972 16.6118C13.7919 16.8196 13.7122 17.2336 13.92 17.5382L15.5746 19.9762Z",
    fill: "#EF3826"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.d00195e0a566644bc027662495cae1ab.svg";
export { ForwardRef as ReactComponent };